import { render, staticRenderFns } from "./AccessoEPermessi.vue?vue&type=template&id=3d9d6f3d&scoped=true"
import script from "./AccessoEPermessi.vue?vue&type=script&lang=js"
export * from "./AccessoEPermessi.vue?vue&type=script&lang=js"
import style0 from "./AccessoEPermessi.vue?vue&type=style&index=0&id=3d9d6f3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9d6f3d",
  null
  
)

export default component.exports